"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Grid from "./webflow_modules/Layout/components/Grid";
import Heading from "./webflow_modules/Basic/components/Heading";
import HtmlEmbed from "./webflow_modules/Embed/components/HtmlEmbed";
import Image from "./webflow_modules/Basic/components/Image";
import Link from "./webflow_modules/Basic/components/Link";
import Paragraph from "./webflow_modules/Basic/components/Paragraph";
import Section from "./webflow_modules/Layout/components/Section";
import SliderArrow from "./webflow_modules/Slider/components/SliderArrow";
import SliderMask from "./webflow_modules/Slider/components/SliderMask";
import SliderNav from "./webflow_modules/Slider/components/SliderNav";
import SliderSlide from "./webflow_modules/Slider/components/SliderSlide";
import SliderWrapper from "./webflow_modules/Slider/components/SliderWrapper";
import Span from "./webflow_modules/Basic/components/Span";
import * as _interactions from "./webflow_modules/interactions";
import { ButtonPrimaryBlack } from "./ButtonPrimaryBlack";
import { ButtonPrimaryWhite } from "./ButtonPrimaryWhite";
import { Communities } from "./Communities";
import { ContactFormHomePage } from "./ContactFormHomePage";
import { FeaturedSlideImage } from "./FeaturedSlideImage";
import { Footer } from "./Footer";
import { Gallery } from "./Gallery";
import { GlobalStyles } from "./GlobalStyles";
import { HeroSubCardComponentContainer } from "./HeroSubCardComponentContainer";
import { HomeHero } from "./HomeHero";
import { MattersCardsGrid } from "./MattersCardsGrid";
import { Navbar } from "./Navbar";

const _interactionsData = JSON.parse(
  '{"events":{"e-31":{"id":"e-31","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-32"}},"mediaQueries":["main"],"target":{"selector":".navbar_interaction-trigger","originalId":"65ee92366d1cabac2751eec4|31f447e0-3d13-9796-7034-ff64324af7cc","appliesTo":"CLASS"},"targets":[{"id":"65ee92366d1cabac2751eec4|31f447e0-3d13-9796-7034-ff64324af7cc","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1702402485163},"e-32":{"id":"e-32","name":"","animationType":"custom","eventTypeId":"SCROLL_OUT_OF_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-16","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-31"}},"mediaQueries":["main"],"target":{"selector":".navbar_interaction-trigger","originalId":"65ee92366d1cabac2751eec4|31f447e0-3d13-9796-7034-ff64324af7cc","appliesTo":"CLASS"},"targets":[{"id":"65ee92366d1cabac2751eec4|31f447e0-3d13-9796-7034-ff64324af7cc","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1702402485163},"e-135":{"id":"e-135","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-136"}},"mediaQueries":["main","medium"],"target":{"id":"a6f77999-6495-9b69-3c8e-0691392f732e","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"a6f77999-6495-9b69-3c8e-0691392f732e","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1709592418887},"e-136":{"id":"e-136","name":"","animationType":"custom","eventTypeId":"SCROLL_OUT_OF_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-16","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-135"}},"mediaQueries":["main","medium"],"target":{"id":"a6f77999-6495-9b69-3c8e-0691392f732e","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"a6f77999-6495-9b69-3c8e-0691392f732e","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1709592418888}},"actionLists":{"a-15":{"id":"a-15","title":"Navbar [transparent]","actionItemGroups":[{"actionItems":[{"id":"a-15-n","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".navbar","selectorGuids":["067842f2-878c-90e2-6ea0-a6e912dff8f1"]},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":0}}]},{"actionItems":[{"id":"a-15-n-2","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".navbar","selectorGuids":["067842f2-878c-90e2-6ea0-a6e912dff8f1"]},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":0}}]}],"useFirstGroupAsInitialState":true,"createdOn":1702402503174},"a-16":{"id":"a-16","title":"Navbar [solid]","actionItemGroups":[{"actionItems":[{"id":"a-16-n-2","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".navbar","selectorGuids":["067842f2-878c-90e2-6ea0-a6e912dff8f1"]},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":1}}]}],"useFirstGroupAsInitialState":false,"createdOn":1702402503174}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function PageComponentHome({
  formSlot = "",
  searchInputSlot = "",
  toggleSearchButtonProps = {},
}) {
  _interactions.useInteractions(_interactionsData);

  return (
    <Block className={"page-component"} tag={"div"}>
      <GlobalStyles />
      <Block className={"page-wrapper"} tag={"div"}>
        <Block
          className={"navbar_interaction-trigger"}
          data-w-id={"a6f77999-6495-9b69-3c8e-0691392f732e"}
          tag={"div"}
        />
        <Navbar />
        <Block className={"main-wrapper"} tag={"main"}>
          <HomeHero
            searchInputSlot={searchInputSlot}
            toggleSearchButtonProps={{
              ...toggleSearchButtonProps,
            }}
          />
          <HeroSubCardComponentContainer />
          <Communities />
          <Section className={"featured"} tag={"section"}>
            <Block className={"featured_wrapper"} tag={"div"}>
              <Block className={"featured_gallery"} tag={"div"}>
                <SliderWrapper
                  animation={"slide"}
                  autoMax={0}
                  autoplay={false}
                  className={"slider"}
                  delay={4000}
                  disableSwipe={false}
                  duration={500}
                  easing={"ease"}
                  hideArrows={false}
                  iconArrows={true}
                  id={"featuredSlider"}
                  infinite={true}
                  navInvert={false}
                  navNumbers={false}
                  navRound={false}
                  navShadow={false}
                  navSpacing={3}
                >
                  <SliderMask className={"mask"}>
                    <SliderSlide className={"featured_slide"} tag={"div"}>
                      <FeaturedSlideImage
                        featuredSlideImageImage={
                          "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dd14e43d93002074633ef2_the-monterey-pool-1080-1080%20(4).jpg"
                        }
                      />
                    </SliderSlide>
                    <SliderSlide className={"featured_slide"} tag={"div"}>
                      <FeaturedSlideImage
                        featuredSlideImageImage={
                          "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dd14e4ced4e9101a35865b_the-monterey-clubhouse-1080-1080.jpg"
                        }
                      />
                    </SliderSlide>
                    <SliderSlide className={"featured_slide"} tag={"div"}>
                      <FeaturedSlideImage
                        featuredSlideImageImage={
                          "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dd14e43d93002074633f1c_the-monterey-null-1080-1080.jpg"
                        }
                      />
                    </SliderSlide>
                    <SliderSlide className={"featured_slide"} tag={"div"}>
                      <FeaturedSlideImage
                        featuredSlideImageImage={
                          "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dd14e34f4da1d2e4daeb14_the-monterey-fitness-center-1080-1080.jpg"
                        }
                      />
                    </SliderSlide>
                    <SliderSlide className={"featured_slide"} tag={"div"}>
                      <FeaturedSlideImage
                        featuredSlideImageImage={
                          "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dd14e43d93002074633f1c_the-monterey-null-1080-1080.jpg"
                        }
                      />
                    </SliderSlide>
                    <SliderSlide className={"featured_slide"} tag={"div"}>
                      <FeaturedSlideImage
                        featuredSlideImageImage={
                          "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dd14e4c6308b01ce93f6af_the-monterey-pool-1080-1080%20(2).jpg"
                        }
                      />
                    </SliderSlide>
                  </SliderMask>
                  <SliderArrow className={"left-arrow"} dir={"left"}>
                    <Block className={"div-block-89"} tag={"div"}>
                      <HtmlEmbed
                        className={"icon-embed-xsmall"}
                        content={
                          '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="iconify iconify--heroicons" width="100%" height="100%" preserveaspectratio="xMidYMid meet" viewbox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"/></svg>'
                        }
                      />
                    </Block>
                  </SliderArrow>
                  <SliderArrow className={"right-arrow"} dir={"right"}>
                    <Block className={"div-block-89"} tag={"div"}>
                      <HtmlEmbed
                        className={"icon-embed-xsmall"}
                        content={
                          '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="iconify iconify--heroicons" width="100%" height="100%" preserveaspectratio="xMidYMid meet" viewbox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"/></svg>'
                        }
                      />
                    </Block>
                  </SliderArrow>
                  <SliderNav className={"hide"} />
                </SliderWrapper>
              </Block>
              <Block className={"featured_description"} tag={"div"}>
                <Block className={"max-width-medium"} tag={"div"}>
                  <Block className={"margin-bottom margin-small"} tag={"div"}>
                    <Block className={"eyebrow"} tag={"div"}>
                      {"Featured Property"}
                    </Block>
                  </Block>
                  <Block className={"margin-bottom margin-xsmall"} tag={"div"}>
                    <Heading tag={"h3"}>{"The MONTEREY"}</Heading>
                  </Block>
                  <Block className={"margin-bottom margin-medium"} tag={"div"}>
                    <Paragraph>
                      {
                        "Situated just outside of Orange County, The Monterey apartment community in Corona boasts a prime location in close proximity to an array of dining establishments, thriving businesses and parks. This exceptional placement makes it the ultimate choice for an idyllic Corona living experience."
                      }
                    </Paragraph>
                  </Block>
                  <Block className={"button-group"} tag={"div"}>
                    <ButtonPrimaryBlack
                      link={{
                        href: "/locations/",
                      }}
                      text={"Find Your Home"}
                    />
                  </Block>
                </Block>
              </Block>
            </Block>
          </Section>
          <Section className={"difference_component"} tag={"section"}>
            <Block className={"padding-global mobile-none"} tag={"div"}>
              <Block className={"container-large"} tag={"div"}>
                <Block className={"mobile-padding-global"} tag={"div"}>
                  <Block className={"communities_header"} tag={"div"}>
                    <Block className={"difference_heading-wrapper"} tag={"div"}>
                      <Heading tag={"h2"}>
                        {"THE SRG "}
                        <Span className={"text-color-blue"}>
                          {"Difference"}
                        </Span>
                      </Heading>
                    </Block>
                    <Block
                      className={"decoration-line is-black"}
                      tag={"wrapper"}
                    />
                  </Block>
                </Block>
                <Block className={"div-block-34"} tag={"div"}>
                  <Block className={"mobile-padding-global"} tag={"div"}>
                    <Block className={"max-width-medium"} tag={"div"}>
                      <Paragraph>
                        {
                          "At SRG Residential, we take utmost pride in being a reliable support system for our residents and employees, fostering strong and vibrant communities where everyone feels valued and cared for. We understand the importance of loving where you live and that's why we are committed to providing hassle-free living experiences."
                        }
                      </Paragraph>
                    </Block>
                  </Block>
                  <Block className={"stats-background"} tag={"div"}>
                    <Block tag={"div"}>
                      <Block className={"heading-style-h6"} tag={"div"}>
                        {"Locations"}
                      </Block>
                      <Block className={"heading-style-h1"} tag={"div"}>
                        {"180+"}
                      </Block>
                    </Block>
                    <Block tag={"div"}>
                      <Block className={"heading-style-h6"} tag={"div"}>
                        {"Founded"}
                      </Block>
                      <Block className={"heading-style-h1"} tag={"div"}>
                        {"1993"}
                      </Block>
                    </Block>
                  </Block>
                </Block>
              </Block>
            </Block>
          </Section>
          <Section className={"matters"} tag={"section"}>
            <Block className={"padding-global"} tag={"div"}>
              <Block className={"container-large"} tag={"div"}>
                <Block className={"padding-section-small"} tag={"div"}>
                  <Block className={"frame-4"} tag={"div"}>
                    <Block tag={"div"}>
                      <Block
                        className={"margin-bottom margin-small"}
                        tag={"div"}
                      >
                        <Heading className={"heading-6"} tag={"h2"}>
                          {"What "}
                          <Span className={"text-color-blue"}>{"Matters"}</Span>
                          <Span className={"text-color-blue"}>{""}</Span>
                        </Heading>
                      </Block>
                      <Block className={"hide-mobile-landscape"} tag={"div"}>
                        <Block className={"button-group"} tag={"div"}>
                          <ButtonPrimaryWhite
                            link={{
                              href: "https://www.sares-regis.com/",
                              target: "_blank",
                            }}
                            text={"About Sares-Regis"}
                          />
                        </Block>
                      </Block>
                    </Block>
                    <Block tag={"div"}>
                      <MattersCardsGrid />
                      <Block className={"show-mobile-landscape"} tag={"div"}>
                        <Block
                          className={"margin-top margin-large"}
                          tag={"div"}
                        >
                          <Block className={"button-group"} tag={"div"}>
                            <ButtonPrimaryWhite text={"About SRG Living"} />
                          </Block>
                        </Block>
                      </Block>
                    </Block>
                  </Block>
                </Block>
              </Block>
            </Block>
          </Section>
          <Gallery />
          <Section className={"testimonials"} tag={"section"}>
            <Block className={"padding-global"} tag={"div"}>
              <Block className={"container-large"} tag={"div"}>
                <Block className={"padding-section-medium"} tag={"div"}>
                  <Block className={"margin-bottom margin-large"} tag={"div"}>
                    <Block className={"text-align-center"} tag={"div"}>
                      <Heading tag={"h2"}>
                        {"From our "}
                        <Span className={"text-color-blue"}>{"Community"}</Span>
                      </Heading>
                    </Block>
                  </Block>
                  <SliderWrapper
                    animation={"outin"}
                    autoMax={0}
                    autoplay={false}
                    className={"testimonial7_component"}
                    data-animation={"slide"}
                    data-duration={"500"}
                    data-infinite={"1"}
                    delay={4000}
                    disableSwipe={false}
                    duration={500}
                    easing={"ease"}
                    hideArrows={false}
                    iconArrows={true}
                    infinite={true}
                    navInvert={true}
                    navNumbers={false}
                    navRound={true}
                    navShadow={false}
                    navSpacing={3}
                  >
                    <SliderMask className={"testimonial7_mask"}>
                      <SliderSlide className={"testimonial7_slide"} tag={"div"}>
                        <Block className={"testimonial7_content"} tag={"div"}>
                          <Block
                            className={"margin-bottom margin-small"}
                            tag={"div"}
                          >
                            <Block className={"heading-style-h6"} tag={"div"}>
                              {
                                "Great staff, always friendly and courteous, very responsive whenever needed, special shout out to Kevin who went above and beyond helping with maintenance issues!!"
                              }
                            </Block>
                          </Block>
                          <Block
                            className={"margin-bottom margin-tiny"}
                            tag={"div"}
                          >
                            <Block className={"text-size-large"} tag={"div"}>
                              {"Patrick on Google"}
                            </Block>
                          </Block>
                          <Block className={"testimonial_address"} tag={"div"}>
                            {"Aliso Creek"}
                          </Block>
                        </Block>
                      </SliderSlide>
                      <SliderSlide className={"testimonial7_slide"} tag={"div"}>
                        <Block className={"testimonial7_content"} tag={"div"}>
                          <Block
                            className={"margin-bottom margin-small"}
                            tag={"div"}
                          >
                            <Block className={"heading-style-h6"} tag={"div"}>
                              {
                                "Can't thank the office ladies enough for being so accommodating and awesome to my family. We were new to the area and they made us feel so welcomed. Grounds are kept, management is great, and amazing location."
                              }
                            </Block>
                          </Block>
                          <Block
                            className={"margin-bottom margin-tiny"}
                            tag={"div"}
                          >
                            <Block className={"text-size-large"} tag={"div"}>
                              {"Alli on Google"}
                            </Block>
                          </Block>
                          <Block className={"testimonial_address"} tag={"div"}>
                            {"Desert Parks Vista"}
                          </Block>
                        </Block>
                      </SliderSlide>
                      <SliderSlide className={"testimonial7_slide"} tag={"div"}>
                        <Block className={"testimonial7_content"} tag={"div"}>
                          <Block
                            className={"margin-bottom margin-small"}
                            tag={"div"}
                          >
                            <Block className={"heading-style-h6"} tag={"div"}>
                              {
                                "I just moved in to Domain Weho. But have to say from the beginning Martin and his team made it the easiest. Everything was fast and efficient. They really are taking care of their residents and make sure they have the best experience living in this beautiful community. Highly recommend!"
                              }
                            </Block>
                          </Block>
                          <Block
                            className={"margin-bottom margin-tiny"}
                            tag={"div"}
                          >
                            <Block className={"text-size-large"} tag={"div"}>
                              {"Ksenia on Google"}
                            </Block>
                          </Block>
                          <Block className={"testimonial_address"} tag={"div"}>
                            {"Domain WeHo"}
                          </Block>
                        </Block>
                      </SliderSlide>
                      <SliderSlide className={"testimonial7_slide"} tag={"div"}>
                        <Block className={"testimonial7_content"} tag={"div"}>
                          <Block
                            className={"margin-bottom margin-small"}
                            tag={"div"}
                          >
                            <Block className={"heading-style-h6"} tag={"div"}>
                              {
                                "The management and maintenance staff at Eastlake deserve special commendation. They are responsive, friendly, and always go above and beyond to address any concerns promptly. It's evident that they prioritize the well-being and satisfaction of their residents. I highly recommend Eastlake to anyone in search of a modern, comfortable, and well-managed living space. It's not just an apartment; it's a community that prioritizes resident satisfaction and offers a lifestyle that exceeds expectations."
                              }
                            </Block>
                          </Block>
                          <Block
                            className={"margin-bottom margin-tiny"}
                            tag={"div"}
                          >
                            <Block className={"text-size-large"} tag={"div"}>
                              {"Chloe on Google"}
                            </Block>
                          </Block>
                          <Block className={"testimonial_address"} tag={"div"}>
                            {"Eastlake 2851"}
                          </Block>
                        </Block>
                      </SliderSlide>
                      <SliderSlide className={"testimonial7_slide"} tag={"div"}>
                        <Block className={"testimonial7_content"} tag={"div"}>
                          <Block
                            className={"margin-bottom margin-small"}
                            tag={"div"}
                          >
                            <Block className={"heading-style-h6"} tag={"div"}>
                              {
                                "Living in this building for just under two years was a delight! The apartments offer plenty of space and are aesthetically pleasing, but the highlight is the dedicated staff. Armando, the maintenance supervisor, deserves special mention. He was always prompt in addressing our concerns, tirelessly ensuring that every detail was attended to with care. His professionalism is unparalleled, and his genuine kindness adds a special touch to the community here."
                              }
                            </Block>
                          </Block>
                          <Block
                            className={"margin-bottom margin-tiny"}
                            tag={"div"}
                          >
                            <Block className={"text-size-large"} tag={"div"}>
                              {"Paula on Google"}
                            </Block>
                          </Block>
                          <Block className={"testimonial_address"} tag={"div"}>
                            {"Etta"}
                          </Block>
                        </Block>
                      </SliderSlide>
                      <SliderSlide className={"testimonial7_slide"} tag={"div"}>
                        <Block className={"testimonial7_content"} tag={"div"}>
                          <Block
                            className={"margin-bottom margin-small"}
                            tag={"div"}
                          >
                            <Block className={"heading-style-h6"} tag={"div"}>
                              {
                                "I've been living here for two years now and I can honestly say that I love this location. I've always been a huge fan of old Spanish architecture, and there is no shortage of that here; the city is absolutely gorgeous. The amenities at this building are great and the managers are awesome. Alondra always helps me with any of my questions or concerns. If you're considering a place in downtown Riverside, definitely set up a tour and ask for Alondra."
                              }
                            </Block>
                          </Block>
                          <Block
                            className={"margin-bottom margin-tiny"}
                            tag={"div"}
                          >
                            <Block className={"text-size-large"} tag={"div"}>
                              {"Smitty on Google"}
                            </Block>
                          </Block>
                          <Block className={"testimonial_address"} tag={"div"}>
                            {"Imperial Hardware Lofts"}
                          </Block>
                        </Block>
                      </SliderSlide>
                      <SliderSlide className={"testimonial7_slide"} tag={"div"}>
                        <Block className={"testimonial7_content"} tag={"div"}>
                          <Block
                            className={"margin-bottom margin-small"}
                            tag={"div"}
                          >
                            <Block className={"heading-style-h6"} tag={"div"}>
                              {
                                "From my initial building tour, move in...it has been a wonderful experience! Veronica, in the front office, is especially kind, responsive and helpful. I tell my friends that I feel like I just moved into a luxury hotel! The property is beautifully maintained and the amenities are very high end. I especially love the outdoor dog walking area so I can walk my dog at night. My maintenance request was addressed within an hour of submitting it. The location in Little Italy is amazing and I love the walkability. We are next to the train tracks and flight path but I find the building to be very quiet. Highly recommend living here :-)"
                              }
                            </Block>
                          </Block>
                          <Block
                            className={"margin-bottom margin-tiny"}
                            tag={"div"}
                          >
                            <Block className={"text-size-large"} tag={"div"}>
                              {"April on Google"}
                            </Block>
                          </Block>
                          <Block className={"testimonial_address"} tag={"div"}>
                            {"Instrata Littley Italy"}
                          </Block>
                        </Block>
                      </SliderSlide>
                      <SliderSlide className={"testimonial7_slide"} tag={"div"}>
                        <Block className={"testimonial7_content"} tag={"div"}>
                          <Block
                            className={"margin-bottom margin-small"}
                            tag={"div"}
                          >
                            <Block className={"heading-style-h6"} tag={"div"}>
                              {
                                "We lived here for 2 years and couldn't say anything but great reviews. Sean and the leasing office are always helpful and on top of concerns within your unit. This is one of the few places where I've lived where the maintenance staff come within 48 hours of an order. Likely shorter and almost immediate with â€œhigher priorityâ€ type of issues. George and Lin are both great. Ended up moving out due to work but highly suggest."
                              }
                            </Block>
                          </Block>
                          <Block
                            className={"margin-bottom margin-tiny"}
                            tag={"div"}
                          >
                            <Block className={"text-size-large"} tag={"div"}>
                              {"Ivan on Google"}
                            </Block>
                          </Block>
                          <Block className={"testimonial_address"} tag={"div"}>
                            {"LINQ"}
                          </Block>
                        </Block>
                      </SliderSlide>
                      <SliderSlide className={"testimonial7_slide"} tag={"div"}>
                        <Block className={"testimonial7_content"} tag={"div"}>
                          <Block
                            className={"margin-bottom margin-small"}
                            tag={"div"}
                          >
                            <Block className={"heading-style-h6"} tag={"div"}>
                              {
                                "Excellent community, I live here and they have good organization, nice social areas, apartments in perfect condition and the best of all is the administration's attention. I recommend them 100%."
                              }
                            </Block>
                          </Block>
                          <Block
                            className={"margin-bottom margin-tiny"}
                            tag={"div"}
                          >
                            <Block className={"text-size-large"} tag={"div"}>
                              {"Jesus On Goole"}
                            </Block>
                          </Block>
                          <Block className={"testimonial_address"} tag={"div"}>
                            {"Miro at the Parc"}
                          </Block>
                        </Block>
                      </SliderSlide>
                      <SliderSlide className={"testimonial7_slide"} tag={"div"}>
                        <Block className={"testimonial7_content"} tag={"div"}>
                          <Block
                            className={"margin-bottom margin-small"}
                            tag={"div"}
                          >
                            <Block className={"heading-style-h6"} tag={"div"}>
                              {
                                "From our first tour to the day we signed our lease, the entire staff at Palomino Apartments when above beyond for my family! They made the process easy to navigate and were kind enough to work with us on our move-in date as we're moving cross-country with our newborn daughter. Thank you to Sydnee, Stephanie, and to everyone else who were there to help us. Looking forward to moving into our new home!"
                              }
                            </Block>
                          </Block>
                          <Block
                            className={"margin-bottom margin-tiny"}
                            tag={"div"}
                          >
                            <Block className={"text-size-large"} tag={"div"}>
                              {"Mike on Goolge"}
                            </Block>
                          </Block>
                          <Block className={"testimonial_address"} tag={"div"}>
                            {"Palomino"}
                          </Block>
                        </Block>
                      </SliderSlide>
                      <SliderSlide className={"testimonial7_slide"} tag={"div"}>
                        <Block className={"testimonial7_content"} tag={"div"}>
                          <Block
                            className={"margin-bottom margin-small"}
                            tag={"div"}
                          >
                            <Block className={"heading-style-h6"} tag={"div"}>
                              {
                                "These apartments are beautiful, I truly enjoy living here. Krista in the front office is always cheerful, and willing to help, never makes me feel like a bother when I have 10,000 questions. The amenities are always well kept, and never too crowded. I could see myself living her for several more years. It's also right down the street from my work!"
                              }
                            </Block>
                          </Block>
                          <Block
                            className={"margin-bottom margin-tiny"}
                            tag={"div"}
                          >
                            <Block className={"text-size-large"} tag={"div"}>
                              {"Zaria on Google"}
                            </Block>
                          </Block>
                          <Block className={"testimonial_address"} tag={"div"}>
                            {"Terracina"}
                          </Block>
                        </Block>
                      </SliderSlide>
                      <SliderSlide className={"testimonial7_slide"} tag={"div"}>
                        <Block className={"testimonial7_content"} tag={"div"}>
                          <Block
                            className={"margin-bottom margin-small"}
                            tag={"div"}
                          >
                            <Block className={"heading-style-h6"} tag={"div"}>
                              {
                                "Extremely well maintained property, fabulous location, and the staff is amazing. Felicia is so helpful. We love living here!"
                              }
                            </Block>
                          </Block>
                          <Block
                            className={"margin-bottom margin-tiny"}
                            tag={"div"}
                          >
                            <Block className={"text-size-large"} tag={"div"}>
                              {"Loren on Google"}
                            </Block>
                          </Block>
                          <Block className={"testimonial_address"} tag={"div"}>
                            {"Trend Design District"}
                          </Block>
                        </Block>
                      </SliderSlide>
                    </SliderMask>
                    <SliderArrow
                      className={"testimonial7_arrow is-left"}
                      dir={"left"}
                    >
                      <Block className={"arrow-icon-container"} tag={"div"}>
                        <HtmlEmbed
                          className={"icon-embed-xsmall"}
                          content={
                            '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="iconify iconify--heroicons" width="100%" height="100%" preserveaspectratio="xMidYMid meet" viewbox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"/></svg>'
                          }
                        />
                      </Block>
                    </SliderArrow>
                    <SliderArrow
                      className={"testimonial7_arrow is-right"}
                      dir={"right"}
                    >
                      <Block className={"arrow-icon-container"} tag={"div"}>
                        <HtmlEmbed
                          className={"icon-embed-xsmall"}
                          content={
                            '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="iconify iconify--heroicons" width="100%" height="100%" preserveaspectratio="xMidYMid meet" viewbox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"/></svg>'
                          }
                        />
                      </Block>
                    </SliderArrow>
                    <SliderNav className={"testimonial7_slide-nav"} />
                  </SliderWrapper>
                </Block>
              </Block>
            </Block>
          </Section>
          <Section className={"contact"} tag={"section"}>
            <Grid className={"contact_component"} tag={"div"}>
              <Block className={"contact_image-wrapper"} tag={"div"}>
                <Image
                  alt={""}
                  className={"contact_image"}
                  height={"auto"}
                  loading={"lazy"}
                  src={
                    "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65d92424f8bed11d14d5ed0f_srg-familyimg.jpeg"
                  }
                  width={"auto"}
                />
              </Block>
              <Block className={"contact_content"} tag={"div"}>
                <Block className={"max-width-medium"} tag={"div"}>
                  <Block className={"margin-bottom margin-medium"} tag={"div"}>
                    <Block className={"margin-bottom margin-small"} tag={"div"}>
                      <Heading tag={"h2"}>{"Contact us"}</Heading>
                    </Block>
                    <Paragraph className={"text-size-small"}>
                      {
                        "You can count on us to be readily available, address inquiries and make sure your home remains a source of comfort and happiness, as you settle in and create lasting memories."
                      }
                      <br />
                      <br />
                      {
                        "If you are a current resident, additional help is available by contacting your community manager through your "
                      }
                      <Link
                        button={false}
                        options={{
                          href: "#",
                        }}
                      >
                        {"resident portal"}
                      </Link>
                      {". *Please no solicitations."}
                    </Paragraph>
                  </Block>
                  <Block className={"margin-bottom margin-large"} tag={"div"}>
                    {formSlot ?? <ContactFormHomePage />}
                  </Block>
                  <Block tag={"div"}>
                    <Block
                      className={"margin-bottom margin-medium"}
                      tag={"div"}
                    >
                      <Heading tag={"h2"}>{"Find a Home"}</Heading>
                    </Block>
                    <Block className={"div-block-37"} tag={"div"}>
                      <Link
                        block={"inline"}
                        button={false}
                        className={"button is-icon"}
                        options={{
                          href: "/locations/",
                        }}
                      >
                        <Block tag={"div"}>{"Locations"}</Block>
                        <HtmlEmbed
                          className={"icon-embed-xsmall"}
                          content={
                            '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="iconify iconify--heroicons" width="100%" height="100%" preserveaspectratio="xMidYMid meet" viewbox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"/></svg>'
                          }
                        />
                      </Link>
                      <Link
                        block={"inline"}
                        button={false}
                        className={"button is-icon"}
                        options={{
                          href: "#",
                        }}
                      >
                        <Block tag={"div"}>{"Residents"}</Block>
                        <HtmlEmbed
                          className={"icon-embed-xsmall"}
                          content={
                            '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="iconify iconify--heroicons" width="100%" height="100%" preserveaspectratio="xMidYMid meet" viewbox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"/></svg>'
                          }
                        />
                      </Link>
                      <Link
                        block={"inline"}
                        button={false}
                        className={"button is-icon"}
                        options={{
                          href: "/applicants/",
                        }}
                      >
                        <Block tag={"div"}>{"Careers"}</Block>
                        <HtmlEmbed
                          className={"icon-embed-xsmall"}
                          content={
                            '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="iconify iconify--heroicons" width="100%" height="100%" preserveaspectratio="xMidYMid meet" viewbox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"/></svg>'
                          }
                        />
                      </Link>
                    </Block>
                  </Block>
                </Block>
              </Block>
            </Grid>
          </Section>
        </Block>
        <Footer />
      </Block>
    </Block>
  );
}
